import React from 'react'
import styled from '@emotion/styled'
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from 'gatsby'
import { formatTitle } from 'utils/conversions'
import { breakpoints } from 'utils/styles'


var slugify = require('slugify')

const pluckCategories = edges =>
  Object.keys(
    edges.reduce((acc, value) => {
    	var categories = value.node.companytype.split(',').map((item)=>item.trim())
      	categories.forEach(item => {
        const category = item.toLowerCase()
        if (!acc[category]) {
          acc[category] = category.toLowerCase()
        }
      })
      return acc
    }, {})
  )

const LinkGrid = styled.div`
	display: grid;
    grid-template-columns: repeat(5,1fr);
    grid-gap: 10px 20px;
    a {
    	color: rgb(0,0,0,.65);
    	font-size: .8rem;
    }
    @media (max-width: ${breakpoints.tablet}px) {
    	grid-template-columns: repeat(4,1fr);
    	grid-gap: 10px;
    }
    @media (max-width: ${breakpoints.mobile}px) {
    	grid-template-columns: repeat(2,1fr);
    	grid-gap: 5px;
    }
`

const Row = styled.div`
	margin-top: 50px;
`

export default (props) => {
	var { edges } = props.data.allGoogleSheetCompaniesRow
	const cat = pluckCategories(edges)
	return (
		<Layout>
			<SEO title="Sitemap" />
			<Row>
				<h4>Companies</h4>
				<LinkGrid>
				{edges.map(({node})=> 
					<Link to={`/${slugify(node.name.toLowerCase())}`}>
						{node.name}
					</Link>
				)}
				</LinkGrid>
			</Row>
			<Row>
				<h4>Categories</h4>
				<LinkGrid>
				{cat.map((c)=> 
					<Link to={`/categories/${slugify(c)}`}>
						{formatTitle(c)}
					</Link>
				)}
				</LinkGrid>
			</Row>
		</Layout>
	)
}


export const query = graphql`
  query SiteMapPageQuery {
    allGoogleSheetCompaniesRow {
	    edges {
	      node {
	        id
	        logo
	        name
	        info
	        access
	        delete
	        californiaonly
	        companytype
	      }
	    }
	  }
  }
`